import React from "react";
import ReactDOM from "react-dom"; // <-- remove /client
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "font-awesome/css/font-awesome.css";
import "@fortawesome/fontawesome-svg-core/styles.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "font-awesome/css/font-awesome.min.css";
import "react-rangeslider/lib/index.css";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/scrollbar";

// Bootstrap table 2
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

// Simplebar
import "simplebar/dist/simplebar.min.css";

// Toastify
import "react-toastify/dist/ReactToastify.css";

// React datepicker
import "react-datepicker/dist/react-datepicker.css";

// Tags input
import "react-tagsinput/react-tagsinput.css";

// Date filter
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file

// React 17 rendering
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// Performance metrics
reportWebVitals();
